export default __webpack_public_path__ + "static/media/worker4-3x.8931dde9.png";